/*
 * @Author: wangalong
 * @LastEditTime: 2022-08-10 16:36:15
 */

/**
 *
 * @param {string} url
 * @returns
 */
export function getStaticUrl(url) {
    if (!url) {
        return url
    }
    if (url.indexOf('http') === 0) {
        return url
    }
    return 'https://static.kaiba315.com.cn/' + url
}

/**
 *
 * @param {string} url
 * @returns
 */
export function getAvatarStaticUrl(url) {
    if (!url) {
        return 'https://static.kaiba315.com.cn/sys/head.png'
    }

    return getStaticUrl(url)
}